import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=1260e20a&scoped=true&"
import script from "./error-404.vue?vue&type=script&lang=js&"
export * from "./error-404.vue?vue&type=script&lang=js&"
import style0 from "./error-404.vue?vue&type=style&index=0&id=1260e20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260e20a",
  null
  
)

export default component.exports